import Timer from "../timer/Timer";

function LaunchCountdown({launchDate, expireReservation}) {
  const secondsRemaining = (new Date(launchDate) - new Date())/1000;

  return <Timer 
      duration={secondsRemaining} 
      expireReservation={expireReservation}
      timerType="launchCountdown"
    />;
}

export default LaunchCountdown;